export default __webpack_public_path__ + "static/TSD_Wrapping_Image-5b309a11b099c0fbcb714af62f590c6c.jpg";